import { render, staticRenderFns } from "./registrasi.vue?vue&type=template&id=23927b06&scoped=true&"
import script from "./registrasi.vue?vue&type=script&lang=js&"
export * from "./registrasi.vue?vue&type=script&lang=js&"
import style0 from "./registrasi.vue?vue&type=style&index=0&id=23927b06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23927b06",
  null
  
)

export default component.exports